import {Component, Input, OnChanges} from '@angular/core';
import {KfRegistration} from '../../../../shared/models/kf-registration.interface';
import {KfRegistrationDetail} from '../../../../kf-data-entry/models/kf-registration-detail.interface';
import {Master} from '../../../../admin/models/master.interface';
import {QuantitativeDetail} from '../../../../kf-data-entry/models/quantitative-detail.interface';
import {FormBuilder} from '@angular/forms';
import {KfRegistrationService} from '../../../../kf-data-entry/services/kf-registration.service';
import {Currency} from '../../../../kf-data-entry/models/currency.interface';
import {Additional} from '../../../../kf-data-entry/models/additional.interface';

@Component({
  selector: 'app-kf-registration-cost-validation-table',
  templateUrl: './kf-registration-cost-validation-table.component.html',
  styleUrls: ['./kf-registration-cost-validation-table.component.scss']
})
export class KfRegistrationCostValidationTableComponent implements OnChanges {

  currencies!: Currency[];

  @Input()
  kfRegistration!: KfRegistration;
  @Input()
  kfRegistrationDetail!: KfRegistrationDetail;
  @Input()
  categories!: Master[];

  displayedColumnsOperations: string[] = ['entry', 'collection', 'logistics', 'treatment', 'total', 'remark'];
  displayedColumnsOverhead: string[] = ['entry', 'clearing-house', 'communication', 'rd', 'office', 'other', 'total', 'remark'];
  additionalDisplayedColumns: string[] = ['entry', 'paymentRetail', 'paymentPoint', 'paymentOther', 'remarks'];
  otherDisplayedColumns: string[] = ['entry', 'remark'];
  additionalDataSource!: Additional[];
  //   [
  //   {entry: 'B. Col. TEE', payment: 0, remark: ''},
  //   {entry: 'Screens', payment: 0, remark: ''},
  //   {entry: 'Lamps', payment: 0, remark: ''},
  //   {entry: 'Large equipment', payment: 0, remark: ''},
  //   {entry: 'Small equipment', payment: 0, remark: ''},
  //   {entry: 'Small IT and Telecom', payment: 0, remark: ''},
  //   {entry: 'PV panel', payment: 0, remark: ''},
  //   {entry: 'Other', payment: 0, remark: ''},
  // ];

  totalCollection = 0;
  totalLogistics = 0;
  totalTreatment = 0;
  operationsTotalValue = 0;

  totalClearingHouse = 0;
  totalCommunication = 0;
  totalRd = 0;
  totalOffice = 0;
  totalOther = 0;
  overheadTotalValue = 0;

  constructor(private formBuilder: FormBuilder,
              private kfRegistrationService: KfRegistrationService) {
  }

  ngOnChanges(): void {
    if (this.kfRegistrationDetail) {
      this.kfRegistrationService.getAllCurrency().subscribe(currencies => this.currencies = currencies);
      this.kfRegistrationDetail.categories.forEach(category => {
        this.totalCollection += category.collection || 0;
        this.totalLogistics += category.logistics || 0;
        this.totalTreatment += category.treatment || 0;
        this.totalClearingHouse += category.clearingHouse || 0;
        this.totalCommunication += category.communication || 0;
        this.totalRd += category.rd || 0;
        this.totalOffice += category.office || 0;
        this.totalOther += category.other || 0;
      });

      this.operationsTotalValue = this.totalCollection + this.totalLogistics + this.totalTreatment;
      this.overheadTotalValue = this.totalClearingHouse + this.totalCommunication + this.totalRd + this.totalOffice + this.totalOther;
    }
    if (this.kfRegistrationDetail?.additional) {
      this.additionalDataSource = this.kfRegistrationDetail.additional;
    }
  }


  getOperationsRowTotalValue(item: QuantitativeDetail): number {
    return this.sum([item.collection, item.logistics, item.treatment]);
  }

  getOverheadRowTotalValue(item: QuantitativeDetail): number {
    return this.sum([item.clearingHouse, item.communication, item.rd, item.office, item.other]);
  }

  sum = (array: number[]) =>  array.reduce((s, v) => s + (v || 0), 0);
}
